var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReuniaoPublica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 144",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h184v144H0z",
    transform: "translate(50 30)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)",
    transform: "translate(-73.4 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 60.9a16 16 0 0 1 2.1-.179 13.9 13.9 0 1 1 0 27.8 14.3 14.3 0 0 1-4.92-.9l-8.46 8.46a7.28 7.28 0 0 0-2.15 5.19v5.2h71.3v-2.2c-.134-4.07-.4-13.6-9.36-16.7a1.94 1.94 0 0 0-.224-.045 59.9 59.9 0 0 1-16.6-7.43 18.6 18.6 0 0 0 3.13-2.82c7.93-8.95 6.63-24.3 6.49-25.7-.537-11-5.73-16.2-9.98-18.7a23 23 0 0 0-11.1-2.91h-.358a23 23 0 0 0-11.1 2.82c-4.34 2.46-9.62 7.7-10.1 18.8a46.2 46.2 0 0 0 .09 9.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 113a6.51 6.51 0 0 0-5.86-3.63h-98v-7.65a9.75 9.75 0 0 1 2.86-6.94l9.22-9.22a3.14 3.14 0 0 0 .358-.448 11.3 11.3 0 0 0 5.51 1.39 11.4 11.4 0 1 0-10.1-5.95 1.75 1.75 0 0 0-.448.358l-9.22 9.22a16.3 16.3 0 0 0-4.79 11.6v7.65h-19.6a6.51 6.51 0 0 0-5.86 3.63 6.44 6.44 0 0 0 .629 6.84l4.12 5.51v.049h.045l20.7 27.6v21.5h85v-21.5l24.8-33.1a6.44 6.44 0 0 0 .626-6.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuniaoPublica);
export default __webpack_public_path__ + "static/media/reuniao-publica.788c826ad4c9a7706a5f365f325c62b1.svg";
export { ForwardRef as ReactComponent };